<script setup lang="ts">
import type { PropType } from "vue";
import type { InputTextProps } from "primevue/inputtext";
import { Field } from "vee-validate";

const value = defineModel<string>({
  get: (val) => val,
  set: (val) => val?.trim(),
});

const props = defineProps({
  name: { type: String, required: true },
  error: { type: String, default: "" },
  size: {
    type: String as PropType<InputTextProps["size"]>,
    default: undefined,
  },
  placeholder: { type: String, default: "" },
  fluid: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  isFormField: { type: Boolean, default: false },
});

const emit = defineEmits<{
  (e: "keydown.enter"): void;
}>();
</script>

<template>
  <Field v-if="isFormField" v-slot="{ field, errorMessage }" :name="name">
    <PgInputText
      v-bind="{
        ...$attrs,
        ...field,
        ...props,
        error: errorMessage,
        isFormField: false,
      }"
      @keydown.enter="emit('keydown.enter')"
    />
  </Field>
  <div v-else :class="[{ 'w-full': fluid }]">
    <InputText
      v-model="value"
      v-bind="{
        ...$attrs,
        invalid: !!error,
        size,
        name,
        placeholder,
        fluid,
        disabled,
      }"
      @keydown.enter="emit('keydown.enter')"
    />
    <div v-if="error" class="mt-2 text-sm text-[#888888]">
      <span class="text-red-500">*</span> {{ error }}
    </div>
  </div>
</template>

<style scoped></style>
